import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const TransactionCreated = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24">
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8736 7.00007L17.6665 4.79297L9.1665 13.293V15.5001H11.3736L19.8736 7.00007ZM11.1665 14.2929L16.9594 8.50005L16.1665 7.70716L10.3736 13.5001L11.1665 14.2929ZM17.6665 7.79294L16.8736 7.00005L17.6665 6.20718L18.4594 7.00007L17.6665 7.79294Z"
      />
      <path d="M6.1665 18.5H19.1665V11H18.1665V17.5H7.1665V6.5H14.1665V5.5L6.1665 5.5V18.5Z" />
    </g>
  </svg>,
  'TransactionCreated'
);
